import React, { useEffect, useState, useRef } from "react";
import HeaderHomeAdmin from "../headers/headerHomeAdmin";
import "../css/Table.scss";
import { Modal, Button } from "react-bootstrap";
import EventLinkModal from "../components/EventLinkModal";
import EventDescription from "../components/EventDescription";
import * as API from "../services/API";
import Footer from "../components/Footer";
import ConfirmModal from "../components/ConfirmModal";
import ErrorModal from "../components/ErrorModal";
import SuccessToast from "../components/SuccessToast";

/* ================= MODAL ================= */

const MyModal = ({ onClose, onAdd, onModify, evenement = null, isUpdate }) => {
  const descriptionInternalRef = useRef(null);
  const descriptionGeneralRef = useRef(null);
  const [linkSelection, setLinkSelection] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState({
    title: evenement?.title || "",
    description_general: evenement?.description_general || "",
    description_internal: evenement?.description_internal || "",
    isShowHome: evenement?.isShowHome || false,
    incoming: evenement?.incoming || false,
    isPrivate: evenement?.isPrivate || false,
    isExternal: evenement?.isExternal || false,
    start_date: evenement?.start_date || "",
    id_image: evenement?.id_image || null,
    extension: ""
  });
  const validate = () => {
    const newErrors = {};

    if (!form.title.trim()) {
      newErrors.title = "Le titre est obligatoire";
    }

    if (!form.start_date) {
      newErrors.start_date = "La date est obligatoire";
    }

    if (!form.description_general.trim()) {
      newErrors.description_general = "La description publique est obligatoire";
    }
    if (!form.description_internal.trim()) {
      newErrors.description_internal = "La description membre est obligatoire";
    }

    // Image obligatoire uniquement à la création
    if (!isUpdate && !form.id_image) {
      newErrors.id_image = "Une image est requise";
    }

    // Date dans le passé (si incoming coché)
    if (form.incoming && form.start_date) {
      const selected = new Date(form.start_date);
      const today = new Date();
      today.setHours(0,0,0,0);

      if (selected < today) {
        newErrors.start_date = "La date doit être future pour un évènement à venir";
      }
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [image, setImage] = useState(evenement?.image || "");

  const updateField = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const openLinkModal = (field, ref) => {
    const textarea = ref.current;
    setLinkSelection({ field, ref, start: textarea.selectionStart, end: textarea.selectionEnd,
      name: form[field].slice(textarea.selectionStart, textarea.selectionEnd) });
  };

  const insertLink = (link) => {
    const { field, ref, start, end } = linkSelection;
    setForm((previous) => ({ ...previous,
      [field]: previous[field].slice(0, start) + link + previous[field].slice(end) }));
    setLinkSelection(null);
    setTimeout(() => {
      ref.current?.focus();
      ref.current?.setSelectionRange(start + link.length, start + link.length);
    }, 0);
  };

  const buildUpdatedValue = () => {
    const updated = {};
    Object.keys(form).forEach((key) => {
      if (form[key] !== evenement[key]) {
        updated[key] = form[key];
      }
    });
    return updated;
  };

  const formatDateForInput = (date) =>
    date ? date.split("T")[0] : "";

  return (
    <>
    <Modal show={!linkSelection} onHide={onClose} size="lg" centered backdrop="static">
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="fw-bold">
          {isUpdate ? "✏️ Modifier l'évènement" : "✨ Créer un évènement"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>

        {/* ===== SECTION INFOS PRINCIPALES ===== */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body">

            <div className="mb-3">
              <label className="form-label fw-semibold">Titre</label>
              <input
                className="form-control"
                value={form.title}
                onChange={(e) => updateField("title", e.target.value)}
              />
            </div>
            {errors.title && (
              <div className="text-danger small mt-1">{errors.title}</div>
            )}
            <div className="mb-3">
              <label className="form-label fw-semibold">Date de l'évènement</label>
              <input
                type="date"
                className="form-control"
                value={formatDateForInput(form.start_date)}
                onChange={(e) => updateField("start_date", e.target.value)}
              />
            </div>
            {errors.start_date && (
              <div className="text-danger small mt-1">{errors.start_date}</div>
            )}
            <div className="row">
              <div className="col-md-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.isShowHome}
                    onChange={(e) => updateField("isShowHome", e.target.checked)}
                  />
                  <label className="form-check-label">
                    Afficher sur l'accueil
                  </label>
                </div>
              </div>

              <div className="col-md-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.incoming}
                    onChange={(e) => updateField("incoming", e.target.checked)}
                  />
                  <label className="form-check-label">
                    Évènement à venir
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.isExternal}
                    onChange={(e) => updateField("isExternal", e.target.checked)}
                  />
                  <label className="form-check-label">
                    Évènement extérieur
                  </label>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={form.isPrivate}
                    onChange={(e) => updateField("isPrivate", e.target.checked)}
                  />
                  <label className="form-check-label">
                    Évènement privé
                  </label>
                </div>
              </div>
            </div>

          </div>
        </div>

        {/* ===== SECTION DESCRIPTIONS ===== */}
        <div className="card border-0 shadow-sm mb-4">
          <div className="card-body">

            <div className="mb-3">
              <label className="form-label fw-semibold">
                Description publique
              </label>
              <div className="mb-2">
                <Button size="sm" variant="outline-secondary" onClick={() => openLinkModal("description_general", descriptionGeneralRef)}>🔗 Insérer un lien</Button>
              </div>
              <textarea
                ref={descriptionGeneralRef}
                className="form-control"
                rows="3"
                value={form.description_general}
                onChange={(e) =>
                  updateField("description_general", e.target.value)
                }
              />
            </div>
            {errors.description_general && (
              <div className="text-danger small mt-1">{errors.description_general}</div>
            )}
            <div>
              <label className="form-label fw-semibold">
                Description membres
              </label>

              <div className="mb-2">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() => openLinkModal("description_internal", descriptionInternalRef)}
                >
                  🔗 Insérer un lien
                </button>
              </div>

              <textarea
                ref={descriptionInternalRef}
                className="form-control"
                rows="4"
                value={form.description_internal}
                onChange={(e) =>
                  updateField("description_internal", e.target.value)
                }
              />
            </div>
            {errors.description_internal && (
              <div className="text-danger small mt-1">{errors.description_internal}</div>
            )}
            <div>

            </div>
          </div>
        </div>

        {/* ===== SECTION IMAGE ===== */}
        <div className="card border-0 shadow-sm">
          <div className="card-body">

            <label className="form-label fw-semibold">Image</label>
            <input
              type="file"
              className="form-control mb-3"
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;

                updateField("extension", file.type.replace("image/", ""));

                const reader = new FileReader();
                reader.onloadend = () => {
                  updateField("id_image", reader.result);
                  setImage(reader.result);
                };
                reader.readAsDataURL(file);
              }}
            />

            {form.id_image && (
              <div className="text-center">
                <img
                  src={image}
                  alt="Image évènement"
                  className="img-fluid rounded shadow-sm"
                  style={{
                    maxHeight: "220px",
                    objectFit: "contain"
                  }}
                />
                <div className="text-muted small mt-2">
                  Aperçu de l'image
                </div>
              </div>
            )}
              {errors.id_image && (
              <div className="text-danger small mt-1">{errors.id_image}</div>
            )}
          </div>
        </div>

      </Modal.Body>

      <Modal.Footer className="border-0 pt-0">
        <Button variant="outline-secondary" onClick={onClose}>
          Annuler
        </Button>

        <Button
          variant="primary"
          className="px-4"
          onClick={() => {
            if (!validate()) return;
            isUpdate
              ? onModify({
                  _id: evenement._id,
                  updatedValue: buildUpdatedValue(),
                })
              : onAdd(form);
          }}
        >
          {isUpdate ? "Enregistrer" : "Créer"}
        </Button>
      </Modal.Footer>
    </Modal>
    {linkSelection && <EventLinkModal initialName={linkSelection.name} onClose={() => setLinkSelection(null)} onInsert={insertLink} />}
    </>
  );
};

/* ================= PAGE ADMIN ================= */

function EvenementsAdmin() {
  const [modalOpen, setModalOpen] = useState(null);
  const [activityList, setActivityList] = useState([]);
  const [search, setSearch] = useState("");
  const [sortOrder, setSortOrder] = useState("desc"); // desc = récent d'abord
  const [filter, setFilter] = useState("all");
  const [confirm, setConfirm] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  
  useEffect(() => {
    refreshList();
  }, []);

  const refreshList = () => {
    API.getAllEvenementRequest(
      (res) => setActivityList(res.data),
      () => {}
    );
  };

  const addEvenement = (data) => {
    API.CreateEvenementRequest(
      data,
      () => {
        refreshList();
        setSuccess("Evenement ajoute avec succes.");
      },
      (err) => setError(err)
    );
    setModalOpen(null);
  };

  const modifyEvenement = ({ _id, updatedValue }) => {
    API.updateEvenementRequest(_id, updatedValue, refreshList, refreshList);
    setModalOpen(null);
  };

  const openAddModal = () =>
    setModalOpen(
      <MyModal onClose={() => setModalOpen(null)} onAdd={addEvenement} />
    );

  const openUpdateModal = (evenement) =>
    setModalOpen(
      <MyModal
        onClose={() => setModalOpen(null)}
        evenement={evenement}
        isUpdate
        onModify={modifyEvenement}
      />
    );
const filteredActivities = activityList
  .filter((e) => {
    const matchSearch =
      e.title.toLowerCase().includes(search.toLowerCase()) ||
      (e.description_general &&
        e.description_general.toLowerCase().includes(search.toLowerCase()));

    const matchFilter =
      filter === "all" ||
      (filter === "incoming" && e.incoming) ||
      (filter === "home" && e.isShowHome)||
      (filter === "external" && e.isExternal) ||
      (filter === "private" && e.isPrivate);

    return matchSearch && matchFilter;
  })
  .sort((a, b) => {
    const dateA = new Date(a.start_date);
    const dateB = new Date(b.start_date);
    return sortOrder === "desc"
      ? dateB - dateA
      : dateA - dateB;
  });
  return (
    <>
      <div
        className="min-vh-100"
        style={{
          backgroundColor: "#f4f6f9"
        }}
      >
        <HeaderHomeAdmin />

        <div className="container py-5">
          <div className="d-flex justify-content-end mb-3">
            <button className="btn btn-dark" onClick={openAddModal}>
              + Créer un évènement
            </button>
          </div>
          <div className="card border-0 shadow-sm mb-4">
            <div className="card-body">
              <div className="row g-3 align-items-center">

                <div className="col-md-4">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="🔍 Rechercher un évènement..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                  >
                    <option value="all">Tous les évènements</option>
                    <option value="incoming">À venir</option>
                    <option value="home">Affichés sur l'accueil</option>
                    <option value="external">Évènements extérieurs</option>
                    <option value="private">Évènements privés</option>
                  </select>
                </div>

                <div className="col-md-4">
                  <select
                    className="form-select"
                    value={sortOrder}
                    onChange={(e) => setSortOrder(e.target.value)}
                  >
                    <option value="desc">Plus récents</option>
                    <option value="asc">Plus anciens</option>
                  </select>
                </div>

              </div>
            </div>
          </div>
          <div className="row g-4">
          {filteredActivities.map((e) => {
            const isIncoming = e.incoming;
            const isHome = e.isShowHome;

            const formattedDate = new Date(e.start_date).toLocaleDateString("fr-FR", {
              year: "numeric",
              month: "long",
              day: "numeric"
            });

            return (
              <div key={e._id} className="col-12 col-md-6 col-lg-4">
                <div className="card border-0 shadow-sm h-100">

                  {/* IMAGE */}
                  {e.image && (
                    <div
                      style={{
                        height: "180px",
                        overflow: "hidden",
                        borderTopLeftRadius: "0.5rem",
                        borderTopRightRadius: "0.5rem"
                      }}
                    >
                      <img
                        src={e.image}
                        alt={e.title}
                        className="w-100 h-100"
                        style={{ objectFit: "cover" }}
                      />
                    </div>
                  )}

                  <div className="card-body d-flex flex-column">

                    {/* TITRE */}
                    <h5 className="fw-bold mb-2">{e.title}</h5>

                    {/* DATE */}
                    <div className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
                      📅 {formattedDate}
                    </div>

                    {/* BADGES */}
                    <div className="mb-3">
                      {isIncoming && (
                        <span className="badge bg-warning text-dark me-2">
                          À venir
                        </span>
                      )}

                      {isHome && (
                        <span className="badge bg-success">
                          Accueil
                        </span>
                      )}
                      {e.isExternal && (
                        <span className="badge bg-info text-dark me-2">
                          Extérieur
                        </span>
                      )}
                       {e.isPrivate && (
                        <span className="badge bg-danger text-dark me-2">
                          Privé
                        </span>
                      )}
                    </div>

                    {/* DESCRIPTION COURTE */}
                    {e.description_general && (
                      <div
                        className="text-muted flex-grow-1"
                        style={{
                          fontSize: "0.9rem",
                          display: "-webkit-box",
                          WebkitLineClamp: 3,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden"
                        }}
                      >
                        <EventDescription value={e.description_general} />
                      </div>
                    )}

                    {/* ACTIONS */}
                    <div className="d-flex justify-content-between align-items-center mt-3">

                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => openUpdateModal(e)}
                      >
                        ✏️ Modifier
                      </button>

                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() =>
                          setConfirm({
                            title: "Supprimer l'évènement?",
                            message: "Cette action est irréversible. Continuer ?",
                            onConfirm: () => API.deleteEvenementRequest(e._id, refreshList, refreshList),
                          })
                          
                        }
                      >
                        🗑 Supprimer
                      </button>

                    </div>

                  </div>
                </div>
              </div>
            );
          })}
        </div>
				<ConfirmModal
					show={!!confirm}
					title={confirm?.title}
					message={confirm?.message}
					onConfirm={confirm?.onConfirm}
					onClose={() => setConfirm(null)}
				/>
          <ErrorModal
            show={!!error}
            message={error}
            onClose={() => setError(null)}
          />
          <SuccessToast
            show={!!success}
            message={success}
            onClose={() => setSuccess(null)}
          />
          {modalOpen}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default EvenementsAdmin;
